import * as React from 'react'
import { useSignal } from '@preact/signals-react'
import { Box } from "@mui/material"
import { CircularPercentageSeeker } from "@ui-seeker/core"
import { formatNumber } from "@ui-seeker/utils"

import { BORDER_COLOR, BORDER_STYLE } from "@constants"
import { NotAllowedBlock } from '@components'
import ScoreColumnPopover from './Popover'
import { useDigitalShelfRedirect } from '../../../@hooks'


export default function valueColumn(name, urlName, showDiff, borderLeft, detailsLabel = '') {

	const circularProps = {
		pattern: [
			{ value: 89, color: "success.light" },
			{ value: 79, color: "success.lighter" },
			{ value: 69, color: "warning.lighter" },
			{ value: 49, color: "warning.light" },
			{ value: 29, color: "error.lighter" },
			{ value: "else", color: "error.light" }
		]
	}

	return {
		name,
		sx: { ...borderLeft && { borderLeft: BORDER_STYLE, borderColor: BORDER_COLOR } },
		render: (value, { groupedID, ...rowData }) => {
			value = value === "" ? 0 : value
			const prev = rowData[`${name}Prev`] || 0
			const valueDiff = rowData[`${name}Diff`]

			return <CellComponent 
				value={value}
				prev={prev}
				valueDiff={valueDiff}
				circularProps= {circularProps} 
				urlName={urlName} 
				data={rowData} 
				detailsLabel={detailsLabel} 
				kpiName={name}
				showDiff={showDiff}
			/>
		}
	}
}

const CellComponent = ({ value, prev, valueDiff, circularProps, urlName, data, detailsLabel, kpiName, showDiff }) => {
    const { urlDetails } = useDigitalShelfRedirect(urlName, data)
    const anchorEl = useSignal(null)

    const absDiff = valueDiff

    return <>
		<Box sx={{ textAlign: "center", cursor: kpiName && value ? "pointer" : "normal" }} onClick={e => anchorEl.value = e.currentTarget} >
			{value !== null
				? <CircularPercentageSeeker
					value={value}
					valueShow={showDiff ? absDiff || 0 : value}
					format={showDiff ? (v) => formatNumber(v, { decimals: 1 }) : null}
					previous={prev}
					sx={{
						cursor: "pointer",
						...showDiff && {
							".circle .insideCircle": {
								color: (absDiff || 0) === 0
									? "disabled.dark"
									: absDiff > 0 ? "success.main" : "error.main"
							}
						}
					}}
					{...circularProps}
				/>
				: <NotAllowedBlock />
			}
		</Box>

		{kpiName && !!value && <ScoreColumnPopover
			anchorEl={anchorEl.value}
			onClose={() => anchorEl.value = null}
			urlDetails={urlDetails}
			detailsLabel={detailsLabel}
			dataRow={data}
			kpiName={kpiName}
		/>}
	</>
}